import { render, staticRenderFns } from "./PreviousStatus.vue?vue&type=template&id=941da8dc&scoped=true"
import script from "./PreviousStatus.vue?vue&type=script&lang=js"
export * from "./PreviousStatus.vue?vue&type=script&lang=js"
import style0 from "./PreviousStatus.vue?vue&type=style&index=0&id=941da8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941da8dc",
  null
  
)

export default component.exports